import React from 'react';
import { Button } from './ui/button';
import { Calendar } from 'lucide-react';

const BookAppointment = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <div className="mb-6">
          <Calendar size={48} className="mx-auto text-gray-700" />
        </div>
        <h2 className="text-3xl font-light mb-4 text-gray-800">
          Schedule your in person or virtual appointment with a Design Consultant
        </h2>
        <Button
          size="lg"
          className="bg-gray-900 hover:bg-gray-800 text-white px-8 py-6 text-lg transition-all duration-300 hover:scale-105"
        >
          Book Now
        </Button>
      </div>
    </section>
  );
};

export default BookAppointment;